import type { RouteRecordRaw } from 'vue-router'
import { AppModule } from '@/config/types'
import type { ProgressResolverParams } from '@/services/resolvers/types'
import { EmailLookupRoutes } from '@/routes/user/lookup/types'

export const getEmailLookupDetailsRoutes = (): RouteRecordRaw[] => [
  {
    name: EmailLookupRoutes.flow,
    path: 'email-lookup/bulk-email-lookup',
    meta: {
      parent: EmailLookupRoutes.index,
      tabTitle: 'pageTabTitle.user.services.emailLookup.flow',
      modules: [AppModule.EmailLookupSession, AppModule.EmailLookupImport],
      resolvers: [
        {
          service: 'ProgressResolver',
          params: {
            serviceIds: ['EmailLookupSessionService'],
          } satisfies ProgressResolverParams,
        },
      ],
    },
    component: () => import('@/components/views/services/emailLookup/EmailLookupFlow.vue'),
  },
]
